import strings from 'localization/strings';

const faqCategories = {
    userAccount: {},
    booking: {},
    payment: {},
    access: {},
    errorReporting: {},
    termination: {},
    rules: {},
    insurance: {},
    forOwners: {}
};

Object.keys(faqCategories).forEach(key => {
    faqCategories[key].key = key;
});

strings.addLoadCallback(() => {
    Object.values(faqCategories).forEach(o => {
        o.title = strings.faqCategories[o.key];
    });
});

export default faqCategories;
